( function( $ ) {

    triggerEvents();

    menuItemEvents();
    
    
    /**
     * Trigger events
     */
    function triggerEvents() {

        var $trigger = $('.js-mm-trig');

        $trigger.on( 'click', function( event ) {

            event.preventDefault();
            $('body').toggleClass( 'mmenu-is-open' );

        } );
    }

    /**
     * Menu Item Events
     */
    function menuItemEvents() {

        toggleSubmenus();

        /**
         * Toggle Submenus
         */
        function toggleSubmenus() {

            $('.js-mmenu-sub-trigger').on( 'click', function( event ) {

                event.preventDefault();

                var $subItems = $(this).next( '.main-item-submenu' );
                var $otherItems = $('.js-mmenu-sub-trigger').not( this ).next( '.main-item-submenu' );

                // Make sure other guys are closed
                $otherItems.removeClass( 'is-collapsed' );

                // Toggle this guy
                $subItems.toggleClass( 'is-collapsed' );


            } );
        }

    }




} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/mmenu.js